namespace DataUtility {
    export const hasValue = (value: any) => {
        if ((value == null) || (value == undefined)) {
            return false;
        }
        if (typeof value === 'number') {
            return true;
        }
        return Object.keys(value)?.length > 0;
    }

    export const isValueChanged = (prevState: any, currentState: any) => {
        let flag = false;
        if (JSON.stringify(prevState) !== JSON.stringify(currentState)) {
            flag = true;
        }

        return flag;
    }

    /**
     * [AI GENERATED CODE]
     * Deep merge objects, modifying the target object
     * Matches lodash _.merge behavior
     */
    export const deepMerge = (target: any = {}, source: any = {}): any => {
        if (typeof source !== 'object' || source === null) {
            return target;
        }

        if (typeof target !== 'object' || target === null) {
            target = Array.isArray(source) ? [] : {};
        }

        for (const key in source) {
            if (source.hasOwnProperty(key)) {
                const sourceValue = source[key];
                const targetValue = target[key];

                if (typeof sourceValue === 'object' && sourceValue !== null &&
                    typeof targetValue === 'object' && targetValue !== null &&
                    !Array.isArray(sourceValue) && !Array.isArray(targetValue)) {
                    // Both are plain objects, merge recursively
                    target[key] = deepMerge(targetValue, sourceValue);
                } else if (typeof sourceValue === 'object' && sourceValue !== null) {
                    // Source is object or array, handle target appropriately
                    if (Array.isArray(targetValue)) {
                        // Target is array, source is object - merge as object into array
                        target[key] = deepMerge(targetValue, sourceValue);
                    } else if (typeof targetValue === 'object' && targetValue !== null) {
                        // Both are objects/arrays, merge recursively
                        target[key] = deepMerge(targetValue, sourceValue);
                    } else {
                        // Target is primitive, replace with source
                        target[key] = Array.isArray(sourceValue) ? [...sourceValue] : { ...sourceValue };
                    }
                } else {
                    // Primitive or null, just assign
                    target[key] = sourceValue;
                }
            }
        }

        return target;
    }

    /**
     * [AI GENERATED CODE]
     * Deep merge with defaults - creates a new object without modifying original
     * Similar to lodash defaultsDeep functionality
     */
    export const deepMergeWithDefaults = (target: any = {}, ...sources: any[]): any => {
        const result = Array.isArray(target) ? [...target] : { ...target };

        for (const source of sources) {
            if (typeof source !== 'object' || source === null) continue;

            for (const key in source) {
                if (source.hasOwnProperty(key)) {
                    if (result[key] === undefined) {
                        result[key] = Array.isArray(source[key]) ? [...source[key]] :
                                     typeof source[key] === 'object' && source[key] !== null ?
                                     { ...source[key] } : source[key];
                    } else if (typeof result[key] === 'object' && result[key] !== null &&
                              typeof source[key] === 'object' && source[key] !== null) {
                        result[key] = deepMergeWithDefaults(result[key], source[key]);
                    }
                }
            }
        }

        return result;
    }

    /**
     * [AI GENERATED CODE]
     * Deep equality comparison for objects and arrays
     * Similar to lodash isEqual functionality
     */
    export const isEqual = (a: any, b: any, _seen = new WeakMap()): boolean => {
        // Handle identical references
        if (a === b) return true;

        // Handle NaN
        if (Number.isNaN(a) && Number.isNaN(b)) return true;

        // Handle null and undefined
        if (a == null || b == null) return a === b;

        // Handle different types
        if (typeof a !== typeof b) return false;

        // Handle primitives
        if (typeof a !== 'object') return false;

        // Handle circular references
        if (_seen.has(a)) {
            return _seen.get(a) === b;
        }
        _seen.set(a, b);

        // Handle Dates
        if (a instanceof Date && b instanceof Date) {
            return a.getTime() === b.getTime();
        }

        // Handle RegExp
        if (a instanceof RegExp && b instanceof RegExp) {
            return a.toString() === b.toString();
        }

        // Handle Arrays
        if (Array.isArray(a) !== Array.isArray(b)) return false;

        if (Array.isArray(a)) {
            if (a.length !== b.length) return false;
            for (let i = 0; i < a.length; i++) {
                if (!isEqual(a[i], b[i], _seen)) return false;
            }
            return true;
        }

        // Handle Objects
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (const key of keysA) {
            if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
            if (!isEqual(a[key], b[key], _seen)) return false;
        }

        return true;
    }

   export const safeJsonParse = (data: any, defaultValue: any = null) => {
        try {
            return data ? JSON.parse(data)  : defaultValue;
        } catch (e) {
            console.error('Error parsing JSON:', e, data);
            return defaultValue;
        }
        return null;
    }
}

export default DataUtility;